import React from 'react'

const AboutPage = () => {
  return (
    <p>This is the About Page</p>
  );
}

export default AboutPage
